import React from 'react'

export default function Footer() {
  return (
    <div className='footer'>
    <h4>Blogger Developed By Gajendra</h4>
    </div>
  )
}
